<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="w-full max-w-md p-8 bg-white rounded shadow-md">
      <h1 class="text-2xl font-bold mb-6 text-center">Login</h1>
      <div v-if="error" class="mb-4 p-4 text-red-700 bg-red-100 border border-red-400 rounded">
        {{ error }}
      </div>
      <form @submit.prevent="login">
        <div class="mb-4">
          <label for="email" class="block text-gray-700">Email:</label>
          <input type="email" v-model="email" required class="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-blue-300">
        </div>
        <div class="mb-6">
          <label for="password" class="block text-gray-700">Password:</label>
          <input type="password" v-model="password" required class="w-full px-3 py-2 border rounded focus:outline-none focus:ring focus:border-blue-300">
        </div>
        <button type="submit" class="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-300">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginView',

  data() {
    return {
      email: '',
      password: '',
      error: ''
    }
  },
  methods: {
    async login() {
      
      try {
        const data = new FormData()
        data.append('grant_type', 'password')
        data.append('client_id', process.env.VUE_APP_API_CLIENT_ID)
        data.append('client_secret', process.env.VUE_APP_API_CLIENT_SECRET)
        data.append('username', this.email)
        data.append('password', this.password)
        data.append('scope', '')

        const response = await axios.post(process.env.VUE_APP_API_OAUTH_URI, data)
        localStorage.setItem('access_token', response.data.access_token)
        this.$router.push('/')
      } catch (error) {
        this.error = 'Invalid credentials'
        console.error('Error logging in:', error)
      }
    }
  }
}
</script>

<style>
/* Add your styles here */
</style>